import { render } from "./SelfAssessmentReport.vue?vue&type=template&id=93412802&scoped=true"
import script from "./SelfAssessmentReport.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentReport.vue?vue&type=script&lang=js"

import "./SelfAssessmentReport.vue?vue&type=style&index=0&id=93412802&scoped=true&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93412802"]])

export default __exports__